export default __webpack_public_path__ + "static/media/IconDesc_Blender.256.06ddaf7d.png";